<!--
일괄기능-출고요청 작업
------------------------------------

-->
<template>
<div class="uk-width-large">
    <!-- 일괄컨트롤러 내 표시될 버튼영역 -->
    <div>        
        <button 
            class="uk-button uk-button-default  uk-button-large uk-width-1-1"
            type="button"
            :disabled="disabled"
            v-on:click="$refs.printworklist.jobInit()"
            title="작업대상 목록을 A4 사이즈로 출력합니다."
        >
            <i class="material-icons" style="vertical-align: middle">list_alt</i>
            PRINT A4 WORK LIST (작업내역 출력)
        </button>
        
        <button 
            class="uk-button uk-button-default uk-button-large uk-width-1-1"
            type="button"
            :disabled="disabled"
            v-on:click="$refs.printbl.jobInit()"
            title="운송장을 출력합니다"
        >
            <i class="material-icons" style="vertical-align: middle">print</i>
            PRINT SHIPPING LABEL (운송장 출력)
        </button>

        <button 
            class="uk-button uk-button-default  uk-button-large uk-width-1-1"
            type="button"
            :disabled="disabled"
            v-on:click="$refs.done.jobInit()"
            title="선택한 배송(BOX)들을 출고대기 상태로 전환합니다"
        >
            <span uk-icon="icon: check"></span>
            Set task to completion (출고대기)
        </button>
    </div>
    
    <!-- DONE 기능 -->
    <app-batch-job-shipout-request-done
        ref="done"
        :batch="batch"
        :csrfToken="csrfToken"
        :region-id="regionId"
    ></app-batch-job-shipout-request-done>

    <!-- 작업내역 출력 기능 -->
    <app-batch-job-shipout-request-print-worklist
        ref="printworklist"
        :batch="batch"
        :csrfToken="csrfToken"
        :region-id="regionId"
    ></app-batch-job-shipout-request-print-worklist>

    <!-- 운송장 출력 기능 -->
    <app-batch-job-shipout-request-print-bl
        ref="printbl"
        :batch="batch"
        :csrfToken="csrfToken"
        :region-id="regionId"
    ></app-batch-job-shipout-request-print-bl>
    
    
</div>
    
</template>

<script>
    export default {
        props: {
            /**
             * 일괄기능 공유data (상세정의는 컨트롤러 참고)
             */
            batch: Object,

            // csrf-token
            csrfToken: String,
            /**
             * 지역id
             */
            regionId: {
                type: Number,
                default: null,
            },
        },
        data: function () {
            
            return {
            };
        },
        computed: {
            // 작업 버튼 비활성화 여부
            disabled() {
                // 선택된 아이템없으면 비활성화
                return this.batch.checked_item_count === 0;
            },

        },
        methods: {
        },
    }
</script>

<style lang="scss" scoped>
</style>